export const civilEngineeringConst = {
  path: "/single-programs/civil-engineering",
  title: "ИНЖЕНЕРНЫЙ ФАКУЛЬТЕТ – СТРОИТЕЛЬНАЯ ИНЖЕНЕРИЯ",
  contentJSX: (
    <>
      <p>
        <strong>Диплом:</strong> бакалавра / магистра
      </p>
      <p>
        <strong>Формы обучения:</strong> очно или дистанционно
      </p>
      <p>
        <strong>Форма связи:</strong> Получить консультацию приемной комиссии
      </p>
      <h2>Строительная инженерия — прочный фундамент вашей карьеры</h2>
      <p>
        Строительная инженерия — это ключевая отрасль, формирующая современный мир. Это сочетание точных расчётов, инженерного мышления и
        инноваций в проектировании и строительстве. Программа даёт всестороннюю подготовку для работы с инфраструктурными объектами,
        зданиями, мостами, тоннелями и другими инженерными системами.
      </p>
      <p>Особое внимание уделяется безопасности, энергоэффективности и устойчивому развитию.</p>
      <h2>Что вы будете изучать?</h2>
      <ul>
        <li>Теория и практика строительных конструкций</li>
        <li>Материаловедение и новые строительные технологии</li>
        <li>Проектирование зданий и сооружений</li>
        <li>Инженерная графика и САПР (AutoCAD, Revit)</li>
        <li>Геотехника и строительная механика</li>
        <li>Организация и управление строительными проектами</li>
        <li>Стандарты и нормы ЕС в строительстве</li>
        <li>Экологическая и противопожарная безопасность</li>
      </ul>
      <p>
        Программа включает лабораторные работы, моделирование строительных процессов, полевые исследования и практики на строительных
        объектах.
      </p>
      <h2>Кем можно работать после окончания?</h2>
      <ul>
        <li>Инженер-строитель</li>
        <li>Проектировщик и конструктор</li>
        <li>Специалист по техническому надзору</li>
        <li>Руководитель строительных проектов</li>
        <li>Эксперт по строительным технологиям и материалам</li>
        <li>Инженер по устойчивому строительству</li>
      </ul>
      <h2>Зарплата в Европе:</h2>
      <p>
        от <strong>€50,000 до €85,000 в год</strong>
      </p>
      <h2>Почему выбирают нас?</h2>
      <ul>
        <li>Европейский диплом с международным признанием</li>
        <li>Гибкая форма обучения — очно или дистанционно</li>
        <li>Обучение на русском или английском языке</li>
        <li>Доступ к современным симуляторам и виртуальным лабораториям</li>
        <li>Преподаватели с практическим опытом работы в строительной отрасли</li>
        <li>Возможность пройти стажировки в крупных инженерных компаниях Европы</li>
      </ul>
      <p>
        <strong>Инженерия, которая создаёт реальность</strong>
      </p>
      <p>
        Наши выпускники работают в частных и государственных компаниях, проектируют жилые комплексы, транспортную инфраструктуру и
        промышленные объекты в странах ЕС и за их пределами.
      </p>
      <br />
      <p className="padding-left">
        «Строительная инженерия — это дисциплина, где каждое решение имеет значение. Мы обучаем будущих инженеров не просто строить, а
        мыслить стратегически.»
      </p>
      <h2>Как поступить?</h2>
      <p>Приёмная комиссия сопровождает вас на каждом этапе — от подачи документов до начала обучения.</p>
    </>
  ),
  contentSearch: `
    Диплом: бакалавра / магистра
    Формы обучения: очно или дистанционно
    Форма связи: Получить консультацию приемной комиссии
    Строительная инженерия — прочный фундамент вашей карьеры
    Строительная инженерия — это ключевая отрасль, формирующая современный мир. Это сочетание точных расчётов, инженерного мышления и инноваций в проектировании и строительстве. Программа даёт всестороннюю подготовку для работы с инфраструктурными объектами, зданиями, мостами, тоннелями и другими инженерными системами.
    Особое внимание уделяется безопасности, энергоэффективности и устойчивому развитию.
    Что вы будете изучать?
    • Теория и практика строительных конструкций
    • Материаловедение и новые строительные технологии
    • Проектирование зданий и сооружений
    • Инженерная графика и САПР (AutoCAD, Revit)
    • Геотехника и строительная механика
    • Организация и управление строительными проектами
    • Стандарты и нормы ЕС в строительстве
    • Экологическая и противопожарная безопасность
    Программа включает лабораторные работы, моделирование строительных процессов, полевые исследования и практики на строительных объектах.
    Кем можно работать после окончания?
    • Инженер-строитель
    • Проектировщик и конструктор
    • Специалист по техническому надзору
    • Руководитель строительных проектов
    • Эксперт по строительным технологиям и материалам
    • Инженер по устойчивому строительству
    Зарплата в Европе: от €50,000 до €85,000 в год
    Почему выбирают нас?
    • Европейский диплом с международным признанием
    • Гибкая форма обучения — очно или дистанционно
    • Обучение на русском или английском языке
    • Доступ к современным симуляторам и виртуальным лабораториям
    • Преподаватели с практическим опытом работы в строительной отрасли
    • Возможность пройти стажировки в крупных инженерных компаниях Европы
    Инженерия, которая создаёт реальность
    Наши выпускники работают в частных и государственных компаниях, проектируют жилые комплексы, транспортную инфраструктуру и промышленные объекты в странах ЕС и за их пределами.
    «Строительная инженерия — это дисциплина, где каждое решение имеет значение. Мы обучаем будущих инженеров не просто строить, а мыслить стратегически.»

    Как поступить?
    Приёмная комиссия сопровождает вас на каждом этапе — от подачи документов до начала обучения.
`,
};
